import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Server-side is the source of truth. We also mirror to localStorage so the
// Phase 2/3 analytics pages (which read the mirror) keep working seamlessly.
export async function fetchDiary() {
  const { data } = await axios.get(`${API}/diary`);
  const entries = data.entries || [];
  localStorage.setItem("asa_diary", JSON.stringify(entries));
  return entries;
}

export async function addDiaryEntry(entry) {
  const { data } = await axios.post(`${API}/diary`, entry);
  const entries = await fetchDiary();
  return { created: data.entry, entries };
}

export async function deleteDiaryEntry(id) {
  await axios.delete(`${API}/diary/${id}`);
  return fetchDiary();
}

export async function saveCheckerResult(payload) {
  try { await axios.post(`${API}/checker`, payload); } catch (e) { console.warn("Checker result not saved to server:", e?.message); }
  localStorage.setItem("asa_last_check", JSON.stringify({
    overall: payload.overall, date: new Date().toISOString().slice(0, 10),
    allergies: payload.allergies, intolerances: payload.intolerances,
    medications: payload.medications, existing: payload.existing, recentIllness: payload.recentIllness,
  }));
}
